const breadCrumb =
  "Lotação de Servidores - Consultas de Informações do Servidor";

const routes = [
  {
    path: "/relatorio-de-servidores-substitutos-e-substituidos",
    name: "relatorio-de-servidores-substitutos-e-substituidos",
    meta: {
      allowedPermissions: ["substituicao_relatorio"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/RelatorioDeServidoresSubstitutosESubstituidos/RelatorioDeServidoresSubstitutosESubstituidos.vue"
      ),
  },
];

export default routes;
